module.exports = __webpack_public_path__ + "static/media/4-4-4.72a6084f.png";